<template>
  <div class="radial-task-counter">
    <svg class="radial-task-meter" viewBox="0 0 32 32" width="120" height="120">
      <circle class="radial-task-progress" :style="progressStyle" cx="16" cy="16" r="15" />
    </svg>
    <div class="radial-task-text">{{ completedTasks }} / {{ totalTasks }}</div>
  </div>
</template>

<script>
export default {
  props: {
    completedTasks: {
      type: Number,
      required: true
    },
    totalTasks: {
      type: Number,
      required: true
    }
  },
  computed: {
    progressStyle() {
      const progress = (this.completedTasks / this.totalTasks) * 100;
      return `stroke-dasharray: ${progress}, 100;`;
    }
  }
};
</script>

<style scoped>
.radial-task-counter {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.radial-task-meter {
  /* width: 280px;
  height: 280px; */
  transform: rotate(-90deg);
  /* border: 1px solid black; */
}

.radial-task-progress {
  fill: none;
  stroke: #3498db;
  stroke-width: 2;
  stroke-dasharray: 0, 100;
  transition: stroke-dasharray 0.5s ease-in-out;
}

.radial-task-text {
  position: absolute;
  /* margin-top: 5px; */
  font-size: 1.2rem;
  color: #333;
}
</style>
